// extracted by mini-css-extract-plugin
export default {"container":"CN-z","modal":"DN-z","dimensions":"EN-z","brandName":"FN-z","productName":"GN-z","labelValue":"HN-z","recipientEmail":"IN-z","recommendedFit":"JN-z","hiddenField":"KN-z"};